import * as actionTypes from "./../../Constants/clients/clientActionTypes";

export function doShowLoader(showLoader = false, loaderMessage) {
    return{
        type: actionTypes.SHOW_LOADER,
        payload: { showLoader, loaderMessage }
    }
}

export function showLoader(shouldShowLoader, loaderMessage = "Loading") {
    return dispatch => {
        return dispatch(doShowLoader(shouldShowLoader, loaderMessage));
    };
}